import React from "react";
import { defineMessages } from "react-intl";
import { Box } from "@mui/material";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { LinkText } from "../link/LinkText.js";
import "../link/LinkButton.js";
import { DropzoneContentIcon } from "./DropzoneContentIcon.js";
const localized = defineMessages({
  dropzoneContentDefaultLinkToChooseFile: {
    id: "DDZ_linkToChooseFile",
    defaultMessage: "choose file"
  },
  dropzoneContentDefaultPlaceholder: {
    id: "DDZ_defaultPlaceholder",
    defaultMessage: "Drag and Drop file here or {linkToDialogWindow}"
  }
});
function DropzoneContentDefault({ isDragOrDialogActive, onOpen }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DropzoneContentIcon, { type: "default", isDragOrDialogActive }), /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(
    LocalizedText,
    {
      label: localized.dropzoneContentDefaultPlaceholder,
      labelParams: {
        linkToDialogWindow: /* @__PURE__ */ React.createElement(
          LinkText,
          {
            title: localized.dropzoneContentDefaultLinkToChooseFile,
            onClick: onOpen,
            underline: isDragOrDialogActive ? "always" : "none"
          }
        )
      }
    }
  )));
}
export {
  DropzoneContentDefault
};
//# sourceMappingURL=DropzoneContentDefault.js.map
